<ng-container [formGroup]="form">
  <ix-chips
    formControlName="initiators"
    [label]="helptextSharingIscsi.initiators_placeholder | translate"
    [tooltip]="helptextSharingIscsi.initiators_tooltip | translate"
  ></ix-chips>
</ng-container>
